/**
 * Ort entity model class
 *
 * This file is part of ePlan
 * (c) Kaden und Partner AG
 */
import { BaseModel } from './BaseModel';
import { BaseCollection } from './BaseCollection';
import type { MutationsObject } from '@kp/js-model';

export const ECH_STATUS = {
    STATUS_NEW: 'new',
    SUBMITTED: 'submitted',
    IN_PROGRESS: 'in progress',
    WITHDRAWN: 'withdrawn',
    SUSPENDED: 'suspended',
    APPELLANT_PROCESS: 'appellant process',
    OBJECTION_PENDING: 'objection pending',
    DECISION_ISSUED: 'decision issued',
    DECISION_LEGALLY_BINDING: 'decision legally binding',
    BUILDING_FREEZE: 'building freeze',
    UNDER_CONSTRUCTION: 'under construction',
    DOSSIER_CLOSED: 'dossier closed',
    DOSSIER_ARCHIVED: 'dossier archived',
    DEMAND_DOCUMENTS: 'demand documents',
    DEMAND_DOCUMENTS_GEMEINDE: 'demand documents gemeinde',
    WAITING_FOR_SIGNATURE: 'waiting for signature'
};

export class Status extends BaseModel {
    id = null;
    bezeichnung = null;
    ech_value = null;
    ebau_value = null;
    plz = null;

    public mutations(): MutationsObject {
        return {
            id: (id) => (Number(id) > 0 ? Number(id) : null)
        };
    }

    getClassName(): string {
        return 'Status';
    }

    get plz_string() {
        return this.plz ? '' + this.plz : '';
    }
}

export class StatusCollection extends BaseCollection<Status> {
    protected modelCls = Status;

    public getModelClassName(): string {
        return 'Status';
    }
}
